export default __webpack_public_path__ + "static/media/github.10794ae7.svg";